var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 39,
    viewBox: "0 0 66 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36012 27.8423V27.8201H1.98785C1.08273 27.8201 0.345505 27.0728 0.345505 26.148V24.8531C0.345505 23.9283 1.08273 23.181 1.98785 23.181H33.3018C33.9515 23.181 34.5427 22.7888 34.8055 22.1821L43.9442 0.998866C44.207 0.39215 44.7982 0 45.4478 0H63.499C64.7107 0 65.5063 1.29482 64.9807 2.40467L53.2508 26.8805C52.9734 27.4576 52.4041 27.8201 51.769 27.8201H51.2946V35.2709C52.1048 35.5817 52.7544 36.2402 53.0464 37.0689H47.4551C47.7179 36.3364 48.2435 35.737 48.9223 35.3967V27.8201H36.258V36.6175C37.4405 36.9431 38.3967 37.8384 38.8128 39H31.7252C32.1047 37.9345 32.9369 37.0911 33.988 36.7063V27.8201H11.9879V35.3449C12.7178 35.6779 13.2872 36.2994 13.5645 37.0689H7.97327C8.25795 36.2698 8.87109 35.6335 9.63751 35.3079V27.8201H5.63021V36.7063C6.67401 37.0911 7.50612 37.9345 7.88569 39H0.79808C1.21414 37.8384 2.17035 36.9431 3.35283 36.6175V27.8423H3.36012Z",
    fill: "#E4DFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector-2.088d0333c7c7221c53b23f198f48a618.svg";
export { ForwardRef as ReactComponent };